import React, { useRef, useState } from "react";
import { MdDelete } from "react-icons/md";
import { ZoneAreaEditorStyled } from "./styled";

const round = (n) => Math.round(n * 100) / 100;
const clamp = (n) => Math.min(100, Math.max(0, n));

// วาดกรอบโซนบนรูปผังฮอลล์: เลือกโซนแล้วลากบนรูป เก็บตำแหน่งเป็น % ของรูป (รูปย่อ/ขยายตามจอก็ยังตรง)
// areas: [{ zone, x, y, w, h }], zones: รหัสโซนที่มีในผังที่นั่ง
const ZoneAreaEditor = ({ src, zones = [], areas = [], onChange, disabled }) => {
  const boxRef = useRef(null);
  const [_zone, _setZone] = useState(zones[0] || "");
  const [_drag, _setDrag] = useState(null);

  const currentZone = zones.includes(_zone) ? _zone : zones[0] || "";

  const pointOf = (e) => {
    const rect = boxRef.current.getBoundingClientRect();
    return {
      x: clamp(((e.clientX - rect.left) / rect.width) * 100),
      y: clamp(((e.clientY - rect.top) / rect.height) * 100),
    };
  };

  const _onPointerDown = (e) => {
    if (disabled || !currentZone || e.button !== 0) return;
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    const start = pointOf(e);
    _setDrag({ start, end: start });
  };

  const _onPointerMove = (e) => {
    if (!_drag) return;
    _setDrag({ ..._drag, end: pointOf(e) });
  };

  const _onPointerUp = () => {
    if (!_drag) return;
    const area = rectOf(_drag);
    _setDrag(null);
    // คลิกเฉยๆ ไม่ลาก ไม่นับเป็นกรอบ
    if (area.w < 1 || area.h < 1) return;
    onChange([...areas, { zone: currentZone, ...area }]);
  };

  const rectOf = ({ start, end }) => ({
    x: round(Math.min(start.x, end.x)),
    y: round(Math.min(start.y, end.y)),
    w: round(Math.abs(end.x - start.x)),
    h: round(Math.abs(end.y - start.y)),
  });

  const style = (area) => ({
    left: `${area.x}%`,
    top: `${area.y}%`,
    width: `${area.w}%`,
    height: `${area.h}%`,
  });

  return (
    <ZoneAreaEditorStyled>
      {!disabled && (
        <div className="zone_pick">
          <span>เลือกโซนแล้วลากบนรูป:</span>
          {zones.map((zone) => (
            <button
              type="button"
              key={zone}
              className={`zone_chip${zone === currentZone ? " active" : ""}`}
              onClick={() => _setZone(zone)}
            >
              {zone}
            </button>
          ))}
        </div>
      )}
      <div
        className={`map_box${disabled ? "" : " drawable"}`}
        ref={boxRef}
        onPointerDown={_onPointerDown}
        onPointerMove={_onPointerMove}
        onPointerUp={_onPointerUp}
        onPointerCancel={() => _setDrag(null)}
      >
        <img src={src} alt="seat map" draggable={false} />
        {areas.map((area, index) => (
          <div className="area" key={`${area.zone}-${index}`} style={style(area)}>
            <span>{area.zone}</span>
          </div>
        ))}
        {_drag && <div className="area drawing" style={style(rectOf(_drag))} />}
      </div>
      {areas.length > 0 && (
        <div className="area_list">
          {areas.map((area, index) => (
            <div className="area_item" key={`${area.zone}-${index}`}>
              <span>
                โซน {area.zone}
                {zones.includes(area.zone) ? "" : " (ไม่มีโซนนี้ในผังที่นั่ง)"}
              </span>
              {!disabled && (
                <MdDelete
                  size={18}
                  style={{ cursor: "pointer" }}
                  onClick={() => onChange(areas.filter((_, i) => i !== index))}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </ZoneAreaEditorStyled>
  );
};

export default ZoneAreaEditor;
